@if (files().length > 0) {
    @if (files().length <= 4) {
        <div
            class="d-flex w-100 gap-2"
            [class.attachments]="!isExternal()"
            [ngClass]="isExternal() ? 'pt-1 pb-1' : ''"
        >
            @for (file of files(); track file.id) {
                <div class="w-25 mw-25">
                    <telxl-panel [hover]="true" bodyClass="ms-1 me-1 p-1">
                        <ng-template #cardBody>
                            <div class="d-flex align-items-center">
                                <div
                                    tabindex="0"
                                    class="left"
                                    [style.cursor]="
                                        canPreview(file) ? 'pointer' : null
                                    "
                                    (click)="
                                        $event.stopPropagation();
                                        $event.preventDefault();
                                        onPreviewFile(file)
                                    "
                                    (keypress)="
                                        $event.stopPropagation();
                                        $event.preventDefault();
                                        onPreviewFile(file)
                                    "
                                >
                                    <div
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        <div
                                            class="d-flex no-wrap overflow-hidden"
                                        >
                                            <span
                                                [style.width.px]="25"
                                                class="me-2"
                                            >
                                                <i
                                                    class="fa-light"
                                                    [ngClass]="fileType(file)"
                                                ></i>
                                            </span>
                                            <span class="text-truncate">
                                                {{ file.name }}
                                            </span>
                                        </div>
                                        @if (!isExternal()) {
                                            <div class="font-md weight-normal">
                                                {{ size(file) }}
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div class="right">
                                    @if (isExternal()) {
                                        <i
                                            class="fa-light fa-download download"
                                            tabindex="1"
                                            (keypress)="
                                                $event.stopPropagation();
                                                $event.preventDefault();
                                                onFileDownload(file)
                                            "
                                            (click)="
                                                $event.stopPropagation();
                                                $event.preventDefault();
                                                onFileDownload(file)
                                            "
                                        ></i>
                                    } @else {
                                        <i
                                            class="fa-light fa-trash-can remove"
                                            tabindex="1"
                                            (keypress)="
                                                $event.stopPropagation();
                                                $event.preventDefault();
                                                onFileDeleted(file)
                                            "
                                            (click)="
                                                $event.stopPropagation();
                                                $event.preventDefault();
                                                onFileDeleted(file)
                                            "
                                        ></i>
                                    }
                                </div>
                            </div>
                        </ng-template>
                    </telxl-panel>
                </div>
            }
        </div>
    } @else {
        <div
            class="d-flex w-100"
            [class.attachments]="!isExternal()"
            [ngClass]="isExternal() ? 'pt-1 pb-1' : ''"
        >
            <telxl-button
                colour="secondary"
                class="w-100 attachments-border"
                (buttonClick)="
                    $event.stopPropagation();
                    $event.preventDefault();
                    onViewMultiple()
                "
            >
                View {{ files().length }} Attachments
                {{ isExternal() ? '' : `(${totalSize()})` }}
            </telxl-button>
        </div>
    }
}
